import type { BoxProps, ModalProps } from '@chakra-ui/react';
import dynamic from 'next/dynamic';
import React from 'react';

const ModalDesktopLazy = dynamic(() => import('./ModalDesktop'));
const ModalMobileLazy = dynamic(() => import('./ModalMobile'));

export interface IModalProps extends ModalProps {
  withCloseButton?: boolean;
  maxW?: number | string;
  withPaddings?: boolean;
  contentProps?: BoxProps;
}
interface IModalContainerProps extends IModalProps {
  isMobile: boolean;
}

const Modal: React.FC<IModalContainerProps> = (props) =>
  props?.isMobile ? (
    <ModalMobileLazy {...props}> {props.children} </ModalMobileLazy>
  ) : (
    <ModalDesktopLazy {...props}> {props.children} </ModalDesktopLazy>
  );

export default Modal;
